export const deploymentType: Readonly<any> = {
    ByVersions: 1,
    ByTask: 2
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/constants/deploymentType.ts